module.exports = __webpack_public_path__ + "img/GEDIA.dfe1bcbd.png";